export default __webpack_public_path__ + "static/media/2.73361bef.jpg";